module.exports = __webpack_public_path__ + "img/text-to-speech.0913f414.svg";